import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { PAUSE, CLICK_PAUSE } from './types';
import { playerEndBufferingAction } from './endBuffering';
import { playerIsBufferingSelector } from '../selectors/isBuffering';
import { episodeEnds, clipEnds } from './index';

export const playerPauseAction = actionCreator(PAUSE);
export const playerClickPauseAction = actionCreator(CLICK_PAUSE);

export const playerPauseThunkAction = () => async (dispatch, getState) => {
  const state = getState();
  if (playerIsBufferingSelector(state)) {
    await dispatch(playerEndBufferingAction({ timestamp: Date.now() }));
  }
  if (!state.player.isPaused) {
    dispatch(clipEnds());
    dispatch(episodeEnds());
  }
  return dispatch(playerPauseAction());
};
